import React, { useCallback } from 'react';
import classNames from 'classnames';
import { makeStyles, Typography, DialogContent } from "../../../../index";
import { useTranslation } from "../../../../hooks/useTranslation";
import { WorkItems } from "./WorkItems";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.default,
        overflowY: 'scroll',
        flex: '1 1 auto',
        display: 'flex',
        alignItems: 'center',
    },
    emptyMessage: {
        color: theme.palette.light.text.hint,
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
}); });
export var WorkSelectDialogContent = function (props) {
    var _a;
    var works = props.works, selectedWorkId = props.selectedWorkId, sortCondition = props.sortCondition, selectable = props.selectable, isLoading = props.isLoading, hasError = props.hasError, onSelectWork = props.onSelectWork;
    var t = useTranslation().t;
    var classes = useStyles();
    var handleSelectWork = useCallback(function (work, selected) {
        onSelectWork(work, selected);
    }, [onSelectWork]);
    var rootClass = classNames(classes.root, (_a = {},
        _a[classes.emptyMessage] = works.length === 0,
        _a));
    if (isLoading) {
        return React.createElement(DialogContent, { className: rootClass });
    }
    if (hasError) {
        return (React.createElement(DialogContent, { className: rootClass },
            React.createElement(Typography, { variant: "title" }, t('読み込みに失敗しました。'))));
    }
    if (works.length === 0) {
        return (React.createElement(DialogContent, { className: rootClass },
            React.createElement(Typography, { variant: "title" }, t('選べるワークがありません。'))));
    }
    return (React.createElement(DialogContent, { className: rootClass },
        React.createElement(WorkItems, { works: works, selectedWorkId: selectedWorkId, selectable: selectable, sortItem: sortCondition.sort, onSelectWork: handleSelectWork })));
};
